import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'monorepo-inspection-completion-success-popup',
  templateUrl: './inspection-completion-success-popup.component.html',
  styleUrls: ['./inspection-completion-success-popup.component.scss'],
})
export class InspectionCompletionSuccessPopupComponent implements OnInit {
  @Input() heading: string = '';
  @Input() resultQuantities: { label: string; value: number | string }[] = [];
  @Input() navigationMessage: string = '';
  constructor() {}

  ngOnInit(): void {}
}
